import React, { useMemo, useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Modal, Select, DatePicker, Button, Spin } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import Table from "../../../core/pagination/datatable";
import GRAN_LOGO1 from "../Logo/Granules_logo1.png";
import { getApiBaseUrl, ADD_ACTIVITY, LOGIN } from "../Config/Config";
import dayjs from "dayjs";
import Swal from "sweetalert2";

const { Option } = Select;
const { RangePicker } = DatePicker;

const FilterDryingCleaningReport = () => {
  const [visible, setVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [filterLoading, setFilterLoading] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [selectedFilterId, setSelectedFilterId] = useState(0);
  const [selectedFilterName, setSelectedFilterName] = useState("All");
  const [dateRange, setDateRange] = useState([
    new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    new Date(), // Current date and time
  ]);
  const [filters, setFilters] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  console.log(dateRange, "date range");
  const user = JSON.parse(sessionStorage.getItem("user")) || {
    UserName: "Unknown User",
    UserID: null,
  };

  const reportConfig = useMemo(() => {
    const now = new Date();
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1);
    const day = pad(now.getDate());
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());
    const seconds = pad(now.getSeconds());
    return {
      ID: "filtercleaning",
      title: "Filter Cleaning Record",
      reportType: "Filter Cleaning",
      filename: `filter_cleaning_report_${year}-${month}-${day}_${hours}-${minutes}-${seconds}`,
      columns: [
        { title: "Filter ID", key: "Lable", dataIndex: "Lable" },
        { title: "Micron", key: "MicronRating", dataIndex: "MicronRating" },
        {
          title: "Filter Cleaning Details",
          children: [
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  Compressed Air <br />
                  Pressure
                </div>
              ),
              key: "WashingAirPressure",
              dataIndex: "WashingAirPressure",
            },
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  RO Water <br />
                  Pressure
                </div>
              ),
              key: "WashingRoWaterPressure",
              dataIndex: "WashingRoWaterPressure",
            },
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  Wash-in
                </div>
              ),
              key: "WashingTime",
              dataIndex: "WashingTime",
              render: (text) => {
                if (!text) return "NA";
                const date = new Date(text);
                const pad = (n) => (n < 10 ? "0" + n : n);
                const day = pad(date.getUTCDate());
                const month = pad(date.getUTCMonth() + 1);
                const year = date.getUTCFullYear();
                const hours = pad(date.getUTCHours());
                const minutes = pad(date.getUTCMinutes());
                const formatted = `${day}/${month}/${year} ${hours}:${minutes}`;
                return formatted.startsWith("01/01/1900") ? "NA" : formatted;
              },
            },
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  Wash-Out
                </div>
              ),
              key: "WashoutTime",
              dataIndex: "WashoutTime",
              render: (text) => {
                if (!text) return "NA";
                const date = new Date(text);
                const pad = (n) => (n < 10 ? "0" + n : n);
                const day = pad(date.getUTCDate());
                const month = pad(date.getUTCMonth() + 1);
                const year = date.getUTCFullYear();
                const hours = pad(date.getUTCHours());
                const minutes = pad(date.getUTCMinutes());
                const formatted = `${day}/${month}/${year} ${hours}:${minutes}`;
                return formatted.startsWith("01/01/1900") ? "NA" : formatted;
              },
            },
            {
              title: "Performed by",
              key: "WashoutUserEmail",
              dataIndex: "WashoutUserEmail",
            },
          ],
        },
        {
          title: "Filter Drying Details",
          children: [
            {
              title: "Dryer Temperature",
              key: "WashinDryerTemp",
              dataIndex: "WashinDryerTemp",
            },
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  Dry-In
                </div>
              ),
              key: "DryInTime",
              dataIndex: "DryInTime",
              render: (text) => {
                if (!text) return "NA";
                const date = new Date(text);
                const pad = (n) => (n < 10 ? "0" + n : n);
                const day = pad(date.getUTCDate());
                const month = pad(date.getUTCMonth() + 1);
                const year = date.getUTCFullYear();
                const hours = pad(date.getUTCHours());
                const minutes = pad(date.getUTCMinutes());
                const formatted = `${day}/${month}/${year} ${hours}:${minutes}`;
                return formatted.startsWith("01/01/1900") ? "NA" : formatted;
              },
            },
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  Dry-Out
                </div>
              ),
              key: "DryOutTime",
              dataIndex: "DryOutTime",
              render: (text) => {
                if (!text) return "NA";
                const date = new Date(text);
                const pad = (n) => (n < 10 ? "0" + n : n);
                const day = pad(date.getUTCDate());
                const month = pad(date.getUTCMonth() + 1);
                const year = date.getUTCFullYear();
                const hours = pad(date.getUTCHours());
                const minutes = pad(date.getUTCMinutes());
                const formatted = `${day}/${month}/${year} ${hours}:${minutes}`;
                return formatted.startsWith("01/01/1900") ? "NA" : formatted;
              },
            },
            {
              title: "Performed by",
              key: "DryOutUserEmail",
              dataIndex: "DryOutUserEmail",
            },
          ],
        },
      ],
      showEquipmentId: false,
    };
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "NA";
    const date = new Date(dateStr.replace("T", " "));
    const pad = (n) => (n < 10 ? "0" + n : n);
    const day = pad(date.getUTCDate());
    const month = pad(date.getUTCMonth() + 1);
    const year = date.getUTCFullYear();
    const hours = pad(date.getUTCHours());
    const minutes = pad(date.getUTCMinutes());
    const formatted = `${day}/${month}/${year} ${hours}:${minutes}`;
    return formatted.startsWith("01/01/1900") ? "NA" : formatted;
  };

  const fetchFilterCleaningData = async () => {
    setFilterLoading(true);
    try {
      const pad = (n) => (n < 10 ? "0" + n : n);

      const start = dateRange[0];
      const end = dateRange[1];

      const formatDateTime = (date) => {
        return (
          date.getFullYear() +
          "-" +
          pad(date.getMonth() + 1) +
          "-" +
          pad(date.getDate()) +
          " " +
          pad(date.getHours()) +
          ":" +
          pad(date.getMinutes()) +
          ":" +
          pad(date.getSeconds())
        );
      };

      const startDate = formatDateTime(start);
      const endDate = formatDateTime(end);

      console.log(startDate, endDate, "formatted");

      const filterId = selectedFilterId || 0;

      const apiUrl = `${getApiBaseUrl()}/api/FiltertimingReport?Filterid=${filterId}&startdate=${encodeURIComponent(
        startDate
      )}&enddate=${encodeURIComponent(endDate)}`;
      console.log("Fetching data with URL:", apiUrl);
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("API Response:", data); // Debug log
      if (data.Status && Array.isArray(data.ResultData)) {
        // Add unique key to each item for Antd Table
        const keyedData = data.ResultData.map((item, index) => ({
          ...item,
          key: item.Lable || item.ID || index,
        }));
        setDataSource(keyedData);
        if (data.ResultData.length === 0) {
          console.log("no data found");
        }
      } else {
        setDataSource([]);
        console.log("no data");
      }
    } catch (error) {
      console.error("Error fetching filter cleaning data:", error);
      setDataSource([]);
    } finally {
      setFilterLoading(false);
    }
  };

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await fetch(
          `${getApiBaseUrl()}/api/getFiltersListDropdown`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("Filters fetched:", data); // Debug log
        const result = data?.ResultData || [];
        setFilters(result);
        if (result.length > 0) {
          setSelectedFilterId(0);
          setSelectedFilterName("All");
        } else {
          setSelectedFilterId(0);
          setSelectedFilterName("All");
        }
      } catch (error) {
        console.error("Error fetching filters:", error);
        setFilters([]);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load filter list. Please try again.",
          confirmButtonColor: "#d33",
        });
      }
    };
    fetchFilters();
  }, []);

  useEffect(() => {
    if (selectedFilterId !== null) {
      fetchFilterCleaningData();
    }
  }, [selectedFilterId, dateRange]);

  const tableColumns = useMemo(
    () =>
      reportConfig.columns.map((col) => ({
        title: col.title,
        dataIndex: col.dataIndex,
        key: col.key,
        children: col.children
          ? col.children.map((child) => ({
              title: child.title,
              dataIndex: child.dataIndex,
              key: child.key,
              render: child.render || ((text) => text || "-"),
              sorter: (a, b) => {
                const valA = a[child.dataIndex] ?? "";
                const valB = b[child.dataIndex] ?? "";
                return typeof valA === "number"
                  ? valA - valB
                  : String(valA).localeCompare(String(valB));
              },
            }))
          : undefined,
        render: col.render || ((text) => text || "-"),
        sorter: col.children
          ? undefined
          : (a, b) => {
              const valA = a[col.dataIndex] ?? "";
              const valB = b[col.dataIndex] ?? "";
              return typeof valA === "number"
                ? valA - valB
                : String(valA).localeCompare(String(valB));
            },
      })),
    [reportConfig]
  );

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );

  const handleExportPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
    });
    const logoWidth = 15;
    const logoHeight = 15;
    const pageWidth = doc.internal.pageSize.getWidth();

    const generateHeader = () => {
      doc.addImage(GRAN_LOGO1, "PNG", 10, 10, logoWidth, logoHeight);
      doc.setFontSize(11);
      doc.text("Granules India Limited", 30, 14);
      doc.text("Gagillapur", 30, 20);
      doc.setFontSize(10);
      doc.setFont(undefined, "bold");
      doc.text(`Title: ${reportConfig.title}`, 10, 35);
      doc.setFont(undefined, "normal");
      return 42;
    };

    const startY = generateHeader();

    const headers = [
      [
        { content: "Filter ID", colSpan: 1 },
        { content: "Micron", colSpan: 1 },
        { content: "Filter Cleaning Details", colSpan: 5 },
        { content: "Filter Drying Details", colSpan: 4 },
      ],
      [
        "",
        "",
        "Compressed Air Pressure",
        "RO Water Pressure",
        "Wash-in",
        "Wash-Out",
        "Performed by",
        "Dryer Temperature",
        "Dry-In",
        "Dry-Out",
        "Performed by",
      ],
    ];

    autoTable(doc, {
      startY: startY,
      head: headers,
      body:
        dataSource.length > 0
          ? dataSource.map((item) => [
              item.Lable || "NA",
              item.MicronRating || "NA",
              item.WashingAirPressure || "NA",
              item.WashingRoWaterPressure || "NA",
              item.WashingTime ? formatDate(item.WashingTime) : "NA",
              item.WashoutTime ? formatDate(item.WashoutTime) : "NA",
              item.WashoutUserEmail || "NA",
              item.WashinDryerTemp || "NA",
              item.DryInTime ? formatDate(item.DryInTime) : "NA",
              item.DryOutTime ? formatDate(item.DryOutTime) : "NA",
              item.DryOutUserEmail || "NA",
            ])
          : [
              [
                {
                  content: "No Data Available",
                  colSpan: 11,
                  styles: { halign: "center" },
                },
              ],
            ],
      theme: "grid",
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: [255, 255, 255],
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        halign: "center",
      },
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 20 },
        2: { cellWidth: 30 },
        3: { cellWidth: 30 },
        4: { cellWidth: 22 },
        5: { cellWidth: 22 },
        6: { cellWidth: 22 },
        7: { cellWidth: 28 },
        8: { cellWidth: 22 },
        9: { cellWidth: 22 },
        10: { cellWidth: 22 },
      },
      margin: { top: startY, bottom: 35 },
      didDrawPage: () => {
        generateHeader();
      },
    });

    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.text(
        `Page ${i} of ${totalPages}`,
        pageWidth - 40,
        doc.internal.pageSize.height - 10
      );
      if (i === totalPages) {
        const pageHeight = doc.internal.pageSize.height;
        const footerY = pageHeight - 20;
        doc.text("Remarks:", 10, footerY - 10);
        doc.text(`Printed by: ${user.UserName}`, 10, footerY);
        const pad = (n) => (n < 10 ? "0" + n : n);
        const start = dateRange[0];
        const end = dateRange[1];
        const startFormatted = `${pad(start.getDate())}-${pad(
          start.getMonth() + 1
        )}-${start.getFullYear()} ${pad(start.getHours())}:${pad(
          start.getMinutes()
        )}`;
        const endFormatted = `${pad(end.getDate())}-${pad(
          end.getMonth() + 1
        )}-${end.getFullYear()} ${pad(end.getHours())}:${pad(
          end.getMinutes()
        )}`;
        doc.text(
          `Date Range: ${startFormatted} - ${endFormatted}`,
          10,
          footerY + 6
        );
        const now = new Date();
        const day = pad(now.getDate());
        const month = pad(now.getMonth() + 1);
        const year = now.getFullYear();
        const hours = pad(now.getHours());
        const minutes = pad(now.getMinutes());
        const seconds = pad(now.getSeconds());
        doc.text(
          `Printed on: ${day}-${month}-${year} ${hours}:${minutes}:${seconds}`,
          10,
          footerY + 12
        );
        doc.text(`Filter: ${selectedFilterName}`, 10, footerY + 18);
      }
    }

    const pdfBlob = doc.output("blob");
    const formData = new FormData();
    formData.append("file", pdfBlob, `${reportConfig.filename}.pdf`);

    fetch(`${getApiBaseUrl()}/api/uploadReportCopy`, {
      method: "POST",
      body: formData,
      headers: {},
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Upload success:", data);
      })
      .catch((err) => {
        console.error("Upload failed:", err);
      });

    doc.save(`${reportConfig.filename}.pdf`);
  };

  const handlePasswordSubmit = async () => {
    if (!password) {
      setPasswordError("Please enter your password");
      return;
    }

    setAuthLoading(true);
    setPasswordError("");
    const username = user?.UserName || user?.Username;
    let loginSuccessful = false;

    try {
      const loginRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const loginData = await loginRes.json();
      if (loginData?.Message === "Login successful") {
        loginSuccessful = true;
      } else {
        setPasswordError(
          "Reauthentication failed. Please check your password."
        );
      }
    } catch (error) {
      console.error("Login error:", error);
      setPasswordError("Something went wrong. Please try again.");
    }

    try {
      const activityPayload = {
        ActivityType: 1,
        PerformedBy: user?.UserID,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: loginSuccessful
          ? `${reportConfig.title} downloaded by ${username}`
          : `Failed Reauthentication for ${reportConfig.title} by ${username}`,
        Location: "Reports",
        IsSucces: loginSuccessful ? 1 : 0,
      };

      const actRes = await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(activityPayload),
      });

      const actData = await actRes.json();
      if (!actData?.success) {
        console.warn("Activity log failed");
      }
    } catch (err) {
      console.error("Activity log error:", err);
    } finally {
      setAuthLoading(false);
      if (loginSuccessful) {
        setVisible(false);
        setPassword("");
        handleExportPDF();
      }
    }
  };

  const handleFilterIdChange = (value) => {
    console.log("Selected Filter ID:", value);
    setSelectedFilterId(value);
    if (value === 0) {
      setSelectedFilterName("All");
    } else {
      const selectedFilter = filters.find((filter) => filter.ID === value);
      setSelectedFilterName(selectedFilter ? selectedFilter.Lable : "All");
    }
  };

  const handleDateRangeChange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      setDateRange([dates[0].toDate(), dates[1].toDate()]);
    } else {
      setDateRange([
        new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
        new Date(),
      ]);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item" aria-current="page">
                    {reportConfig.title}
                  </h4>
                </ol>
              </nav>
              <h6>Manage your filter cleaning records</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link
                  to="#"
                  onClick={() => {
                    setVisible(true);
                    setPassword("");
                    setPasswordError("");
                  }}
                >
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap gap-3">
              <div style={{ width: 320 }}>
                <Select
                  style={{ width: "100%" }}
                  value={selectedFilterId}
                  onChange={handleFilterIdChange}
                  placeholder="Select Filter ID"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  <Option key={0} value={0}>
                    All
                  </Option>
                  {filters?.map((filter) => (
                    <Option key={filter?.ID} value={filter?.ID}>
                      {filter?.Lable}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="d-flex align-items-center gap-2">
                <RangePicker
                  showTime={{ format: "HH:mm" }}
                  value={[dayjs(dateRange[0]), dayjs(dateRange[1])]}
                  onChange={handleDateRangeChange}
                  format="DD-MM-YYYY HH:mm"
                  style={{ width: 350 }}
                  defaultValue={[dayjs(dateRange[0]), dayjs(dateRange[1])]}
                />
                <Button
                  type="primary"
                  onClick={fetchFilterCleaningData}
                  loading={filterLoading}
                >
                  Apply
                </Button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {filterLoading ? (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <Spin size="large" />
                </div>
              ) : dataSource.length > 0 ? (
                <Table
                  columns={tableColumns}
                  dataSource={dataSource}
                  bordered
                  rowKey={(record) => record.key}
                />
              ) : (
                <table className="table table-bordered">
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td colSpan={tableColumns.length} className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Confirm Password"
        open={visible}
        onCancel={() => {
          setVisible(false);
          setPassword("");
          setPasswordError("");
        }}
        onOk={handlePasswordSubmit}
        confirmLoading={authLoading}
        okText="Verify & Download"
        width={350}
      >
        <div className="mb-3">
          <div className="pass-group">
            <input
              type={showPassword ? "text" : "password"}
              className={`form-control ${passwordError ? "is-invalid" : ""}`}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (passwordError) setPasswordError("");
              }}
              autoComplete="new-password"
              onCopy={(e) => e.preventDefault()}
              onPaste={(e) => e.preventDefault()}
              onCut={(e) => e.preventDefault()}
            />
            <span
              className={`ti toggle-password ${
                showPassword ? "ti-eye" : "ti-eye-off"
              }`}
              onClick={() => setShowPassword((prev) => !prev)}
            ></span>
          </div>
          {passwordError && (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {passwordError}
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default FilterDryingCleaningReport;
